import { render, staticRenderFns } from "./SingleOffer.vue?vue&type=template&id=b1ae7eb4&"
import script from "./SingleOffer.vue?vue&type=script&lang=ts&"
export * from "./SingleOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports